import axios from "axios";

let baseUrl = process.env.REACT_APP_API_BASE_URL;

let userToken = "";
const accessToken = localStorage.getItem("accessToken")
  ? JSON.parse(localStorage.getItem("accessToken")).accessToken
  : null;

const post = (endpoint, data) => {
  let url = baseUrl + endpoint;
  let headers = getHeaders();
  return axios
    .post(url, data, { headers })
    .then(handleSuccess)
    .catch(handleError);
};

const get = async (endpoint) => {
  let url = baseUrl + endpoint;
  let headers = getHeaders();
  return await axios
    .get(url, { headers })
    .then(handleSuccess)
    .catch(handleError);
};

const put = (endpoint, data) => {
  let url = baseUrl + endpoint;
  let headers = getHeaders();
  return axios
    .put(url, data, { headers })
    .then(handleSuccess)
    .catch(handleError);
};

function handleSuccess(res) {
  return res.data;
}

function handleError(err) {
  throw err?.response?.data?.message;
}

function getHeaders() {
  let headers = {
    Accept: "application/json",
    "Content-Type": "Application/json",
    Authorization: `Bearer ${accessToken ? accessToken : userToken}`,
  };
  return headers;
}

export function setToken(token) {
  userToken = token;
}

let functions = {
  post,
  get,
  put,
};

export default functions;

export const fetchReports = async (
  mealTypeId,
  locationId,
  startDate,
  endDate
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports`,
      {
        params: {
          mealTypeId,
          locationId,
          startDate,
          endDate,
        },
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Fetch Reports API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};

export const fetchReportDetail = async (mealTypeId, locationId, date) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reports/${date}`,
      {
        params: {
          mealTypeId,
          locationId,
        },
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Fetch Reports API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};

export const updateEmployeePassword = async (employeeId, newPassword) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/employee/${employeeId}`,
      {
        password: newPassword,
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update Employee Password API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};
